(function () {
  var s = document.createElement("script");
  var h = document.querySelector("head") || document.body;
  s.src = "https://acsbapp.com/apps/app/dist/js/app.js";
  s.async = true;
  s.onload = function () {
    acsbJS.init({
      statementLink: "",
      footerHtml: "",
      hideMobile: true,
      hideTrigger: true,
      disableBgProcess: false,
      language: "en",
      position: "left",
      leadColor: "#383734",
      triggerColor: "#383738",
      triggerRadius: "50%",
      triggerPositionX: "left",
      triggerPositionY: "bottom",
      triggerIcon: "people",
      triggerSize: "small",
      triggerOffsetX: 16,
      triggerOffsetY: 16,
      mobile: {
        triggerSize: "small",
        triggerPositionX: "left",
        triggerPositionY: "bottom",
        triggerOffsetX: 8,
        triggerOffsetY: 8,
        triggerRadius: "50%",
      },
    });
  };
  h.appendChild(s);
})();
